export default __webpack_public_path__ + "static/media/beep.bf629403.mp3";